<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))"
                v-model="queryParam.orderNo"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model="queryParam.mobileNo"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('name')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('names'))"
                v-model="queryParam.names"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="{ x: 'max-content' }"
        :pagination="false"
        :loading="loading"
        bordered
      >
        <Dict slot="loanStatus" slot-scope="text" :dict-code="DICT_CODE.LOAN_STATUS" :value="text" />
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS" :value="text" />
        <Dict slot="settleStatus" slot-scope="text" :dict-code="DICT_CODE.INSTALLMENT_SETTLE_STATUS" :value="text" />
        <Dict slot="overdueStatus" slot-scope="text" :dict-code="DICT_CODE.OVERDUE_STATUS" :value="text" />
        <span slot="action" slot-scope="text, record">
          <a @click="cancelOrder1(record)"> {{ $t('investorList.Downloadcontract') }} </a>
        </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getInstallmentPlatformAllOrderListPrd } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { transformTime } from '@/components/_util/util'
import { downloadContracts } from '@/webpublicapi/vietnamBackstage'
import { FenToDong } from '@/utils/filter'

const I18N_KEY = 'order.'
export default {
  name: 'TestInstallOrderList',
  components: {
    Dict,
  },
  data() {
    return {
      I18N_KEY,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      queryParam: {
        orderNo: '',
        mobileNo: '',
        names: '',
      },
      loading: false,
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'center',
          dataIndex: 'orderNo',
        },
        {
          title: this.$t('phoneNo'),
          align: 'center',
          dataIndex: 'mobileNo',
        },
        {
          title: this.$t('names'),
          align: 'center',
          dataIndex: 'names',
        },
        {
          title: 'appssid',
          align: 'center',
          dataIndex: 'appSsid',
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'center',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' },
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'center',
          dataIndex: 'applyAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY + 'deadline'),
          align: 'center',
          dataIndex: 'duration',
        },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'center',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' },
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'center',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' },
        },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'center',
          dataIndex: 'createdTime',
          customRender: (text) => (text ? transformTime(text, 2) : '-'),
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      getInstallmentPlatformAllOrderListPrd(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.total = res.data.total
            this.dataSource = res.data.rows
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    searchReset() {
      this.queryParam.orderNo = ''
      this.queryParam.mobileNo = ''
      this.queryParam.names = ''
      this.loadData(this.form.pageNum)
    },
    cancelOrder1(record) {
      const hide = this.$message.loading(this.$t('investorList.downloading') || 'Downloading, please wait...', 0)
      downloadContracts({ orderId: record.id })
        .then((res) => {
          hide()
          if (!(res instanceof Blob)) {
            this.$message.error(this.$t('investorList.sb'))
            return
          }
          if (res.type && res.type.includes('application/json')) {
            res.text().then((text) => {
              try {
                const json = JSON.parse(text)
                this.$message.error(json.msg || this.$t('investorList.sb'))
              } catch (e) {
                this.$message.error(this.$t('investorList.sb'))
              }
            })
            return
          }
          const url = window.URL.createObjectURL(res)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = record.orderNo + '.zip'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        })
        .catch((e) => {
          hide()
          this.$message.error(e.message)
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
